"use client";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { HeartIcon } from "@heroicons/react/24/outline";

import { Spinner } from "@/components/ui/spinner";

import { usePostFavorite } from "@/queries/mutations/use-post-favorite";

import type { House } from "@/types";

interface Props {
  estate: House;
  revalidateMainListPath?: boolean;
}

export const FavoriteIconButton = ({
  estate,
  revalidateMainListPath,
}: Props) => {
  const { save, isPending, isFavorite } = usePostFavorite({
    initialFavorite: estate.favorito,
    revalidateMainListPath,
  });
  const text = isFavorite ? "Remover dos favoritos" : "Favoritar";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          disabled={isPending}
          aria-label={text}
          className="absolute z-[1] right-1.5 p-1 bg-gray-50 hover:bg-gray-200 rounded-sm transition-colors top-1.5"
          onClick={() => save(estate.id)}
        >
          {isPending ? (
            <Spinner />
          ) : (
            <HeartIcon
              aria-hidden="true"
              className={`w-4 h-w-4 ${
                isFavorite ? "text-red-500 fill-current" : "text-gray-400"
              }`}
            />
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent>
        <p>{text}</p>
      </TooltipContent>
    </Tooltip>
  );
};
